import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import {
    ORDER_STATE,
    WAITER_TYPES,
    CONFIRM_DIALOG_TYPE,
    getCurrencyIcons,
    DELIVERY_STRATEGY, getExternalCourierProviderNameByProvider
} from "../../../utils/enums";
import { getStaticTime } from "../../../utils/convertTime";
import { isAllowOrderDeleteWithoutPassword } from "../../../services/restaurant";
import {
    getUIName,
    getAddress,
    getConvertedTargetTime,
    getFormattedDeliveryDuration, getOrderArrivalEstimation, getIsShowReadinessTime, isShowETAForOrder
} from "../../../services/order";
import { getAppartmentNumber } from '../../../services/order';
import { isRTL, getCourierNameById, isExistStatusDelivery, getConfirmUsers } from "../../../services/userModel";
import {defaultPromiseResolve, isEmpty} from "../../../utils/objects-util";

import Waiter from "../Waiter/Waiter";
import EditButtonsBlock from "./EditButtonsBlock";
import TimeBox from "../TimeBox/TimeBox";
import ConfirmCombo from "../ConfirmCombo";
import IconButton from "../IconButton";
import OrderTitleInfo from "../OrderTitleInfo";

const ActiveOrderInfoMore = ({
  t,
  item,
  users,
  orders,
  user,
  courierConfirmDialogType,
  showOrderPaymentStatus,
  isAssistanceOrder,
  isWithPassword,
  isEditDelivery,
  userInfoItem,
  showConfirmDialog,
  getOrderStatusLabeltext,
  getIsShowAssociate,
  getIsShowReady,
  handleOnShowOrdersMore,
  handleOnChangeOrderState,
  handleOpenAssociatePopup,
  handleOnConfirmDialog,
  handleOnCancelConfirmDialog,
  handleOnEdit,
  getIsShowPickedUp,
  handleOnShowConfirmDialog,
  handleOnPreviewClick,
  handleApplyCourierDelivery,
  handleOnEditDelivery,
  getProviderById,
}) => (
  <div className={classNames("userInfoItems")}>
    <div
      className={classNames("userInfoItemColumn", "userInfo", {
        assistance: isAssistanceOrder
      })}
    >
      {userInfoItem(
        <div className={classNames("titleBlock")}>
          <div className={classNames("userNameContainer")}>
            <OrderTitleInfo order={item} isWithId />
            {getAppartmentNumber(item) && (
              <span> {t("dashboard.orders.APPARTMENT")}:&nbsp;{getAppartmentNumber(item)}</span>
            )}
          </div>        
          {item.isHighPriority && (
            <div className={classNames("vipStatus", "inlineFlex")}>
              <IconButton isIcon={true} iconName="crown" onClick={defaultPromiseResolve} />
            </div>
          )}
        </div>,
        null,
        "noBorder"
      )}
      {userInfoItem(
        <div className={classNames("lineBlock")}>
            <div className={classNames("lineBlockItem")}>
              <div className={classNames("itemIcon", "name")} />
              <div className={classNames("itemTitle")}>
                {t("orders.ORDER_NUMBER_NAME_LABEL")}
                :&nbsp;
              </div>
              <div className={classNames("itemValue")}>
                <div>{item.orderId}</div>
                <div>/</div>
                <div>{getUIName(item)}</div>
              </div>
            </div>
        </div>,
        <div className={classNames("lineBlock")}>
          <span>&nbsp;</span>
        </div>
      )}
      {userInfoItem(
        <div className={classNames("lineBlock")}>
          <div className={classNames("lineBlockItem")}>
            <div className={classNames("itemIcon", "phone")} />
            <div className={classNames("itemTitle")}>
              {t("orders.PHONE_LABEL")}
              :&nbsp;
            </div>
            <div className={classNames("itemValue")}>
              <div>{item.consumerPhone || ""}</div>
            </div>
          </div>
        </div>,
        <div className={classNames("lineBlock")}>
          <span>&nbsp;</span>
        </div>
      )}
      {userInfoItem(
        <div className={classNames("lineBlock")}>
          <div className={classNames("lineBlockItem")}>
            <div className={classNames("itemIcon", "notes")} />
            <div className={classNames("itemTitle")}>
              {t("orders.NOTES_LABEL")}
              :&nbsp;
            </div>
            <div className={classNames("itemValue")}>
              <div>{item.notes || "-"}</div>
            </div>
          </div>
        </div>,
        <div className={classNames("lineBlock")}>
          <span>&nbsp;</span>
        </div>
      )}
      {userInfoItem(
        <div className={classNames("lineBlock")}>
          <div className={classNames("lineBlockItem")}>
            <div className={classNames("itemIcon", "place")} />
            <div className={classNames("itemTitle")}>
              {t("orders.ADDRESS_LABEL")}
              :&nbsp;
            </div>
            <div className={classNames("itemValue")}>
              <div>{getAddress(item.address)}</div>
            </div>
          </div>
        </div>,
        <div className={classNames("lineBlock")}>
          <span>&nbsp;</span>
        </div>
      )}
      {userInfoItem( null,
        <div className={classNames("lineBlock")}>
          <div className={classNames("status")}>
            {isExistStatusDelivery(item) && (
              <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>
                  {t("orders.COURIER_GROUP_LABEL")}
                  :&nbsp;
                </span>
                <span className={classNames("statusValue")}>
                  {getCourierNameById(item.groupId)}
                </span>
              </div>
            )}
            {item.state === ORDER_STATE.delivered && (
              <div className={classNames("deliveryBy")}>
                {!isEditDelivery && (
                  <IconButton isIcon={true} 
                    iconName={"orderEdit"} 
                    tooltipText={t("dashboard.orders.EDIT_ORDER_DELIVERY")}
                    onClick={handleOnEditDelivery} 
                  />
                )}
              </div>
            )}
            {item.state === ORDER_STATE.delivered && (
              <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>
                  {t("orders.DELIVERED_BY_LABEL")}
                  :&nbsp;
                </span>
                {!isEditDelivery && (
                  <span>
                      {item.deliveryProviderId ? (
                          getProviderById(item.deliveryProviderId)?.name
                      ) : (
                          <>
                              {item && !isEmpty(item.deliveryProvider) && getExternalCourierProviderNameByProvider(item.deliveryProvider)}
                              {item && isEmpty(item.deliveryProvider) && (getCourierNameById(item.deliveryBy) || "-")}
                          </>
                      )}
                  </span>
                )}
                {isEditDelivery && (
                  <ConfirmCombo
                    values={getConfirmUsers(users)}
                    comboKey="userId"
                    comboValueField={["firstName", "lastName"]}
                    onApply={handleApplyCourierDelivery}
                    onCancel={handleOnEditDelivery}
                  />
                )}
              </div>
            )}
              {!isAssistanceOrder && (
                  <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>
                  {t("orders.STATUS_LABEL")}
                    :&nbsp;
                </span>
                      <span>{getOrderStatusLabeltext()}</span>
                  </div>
              )}
          </div>
        </div>,
        <div className={classNames("lineBlock")}>
          <span>&nbsp;</span>
        </div>,
        "noBorder"
      )}
      {userInfoItem(
        <div className={classNames("footerAction")}>
          <div className={classNames("link")} onClick={handleOnShowOrdersMore}>
            {t("orders.CONTENTS_LESS")}
          </div>
        </div>,
        <div className={classNames("status")} />,
        "noBorder"
      )}
    </div>
      <div className={classNames("userInfoItemColumn", "order", { assistance: isAssistanceOrder })}>
          {userInfoItem(
              <div className="receiveLabel">
                  {t("orders.RECEIVED_AT_LABEL")}:&nbsp;{getStaticTime(item.date, false, isRTL())}
                  {isShowETAForOrder() && (
                      <div>
                          {t("orders.ETA_LABEL")}
                          :&nbsp;
                          {getOrderArrivalEstimation(item, user, (orders || []).filter(f=> user && f.groupId === user.userId))}
                      </div>
                  )}
              </div>,
              <div className={classNames("receiveLabel")}>
                  <TimeBox date={item.date} />
              </div>,
              "noBorder"
          )}
          {(getIsShowReadinessTime(item) || item.deliveryStrategy === DELIVERY_STRATEGY.concreteTime) && userInfoItem(
              <div className={classNames("receiveLabel")}>

              </div>,
              <div className={classNames("receiveLabel")}>
                  {item.deliveryStrategy === DELIVERY_STRATEGY.concreteTime && (
                      <span>{getConvertedTargetTime(item)}</span>
                  )}
                  {/*<ReadinessTimeInfo value={item} />*/}
              </div>,
              "toBottom responsiveBottom"
          )}
          {item &&
          item.deliveryBy &&
          item.state === ORDER_STATE.delivered &&
          userInfoItem(
              <div className={classNames("titleBlock")}>
                  {t("orders.DELIVERED_AT_LABEL")}
                  :&nbsp;
                  {getStaticTime(item.deliveryTime, false, isRTL())}
              </div>,
              <div className={classNames("titleBlock")}>
                  {t("orders.DELIVERY_DURATION_LABEL")}
                  :&nbsp;
                  {getFormattedDeliveryDuration(item)}
              </div>,
              "toBottom responsiveBottom"
          )}
          {item?.timesInfo?.externalProviderAssignmentTime && userInfoItem(<div className={classNames("titleBlock")}>
                  {t("orders.EXTERNAL_PROVIDER_ASSIGNMENT_TIME")}
                  :&nbsp;
                  {getStaticTime(item?.timesInfo?.externalProviderAssignmentTime, false, isRTL())}
              </div>,
              <div className={classNames("titleBlock")}></div>, "noBorder")}
      </div>
    <div
      className={classNames("userInfoItemColumn", "payment", {
        assistance: isAssistanceOrder
      })}
    >
      {userInfoItem(
        <div className={classNames("titleBlock")}>
          <div>{t("orders.PAYMENT_LABEL")}</div>
        </div>,
        <div>&nbsp;</div>
      )}
      <div className={classNames("payments")}>
        {item.payments &&
          item.payments.map((payment, index) =>
            userInfoItem(
              <div key={`payment-${item.id || item.orderId}-${index}`}
                className={classNames("paymentIcon", { isCache: payment.isCache })}
              />,
              <div className={classNames("inlineFlex")}>
                {payment.amount}
                {showOrderPaymentStatus && (
                  <IconButton isIcon={true} 
                    active={true} 
                    iconName={payment.isPaid ? "applyActive" : "noIsPaid"} 
                    tooltipText={payment.isPaid 
                      ? t("dashboard.orders.IS_PAID_TOOLTIP_LABEL")
                      : t("dashboard.orders.IS_NOT_PAID_TOOLTIP_LABEL")
                    }
                    onClick={defaultPromiseResolve} 
                  />
                )}
              </div>,
              null,
              `payment-${item.id || item.orderId}-${index}`
            )
          )}
      </div>
      {userInfoItem(
        <div className={classNames("titleBlock")}>
          {t("dashboard.orders.TOTAL_LABEL")}
        </div>,
        <div className={classNames("titleBlock")}>{`${
          item.amount || 0
        } ${getCurrencyIcons(item.currency)}`}</div>,
        "toBottom"
      )}
    </div>
    <div
      className={classNames("userInfoItemColumn", "orderStatus", {
        assistance: isAssistanceOrder
      })}
    >
      <div className={classNames("orderStatusControl")}>
        {item.state === ORDER_STATE.new && (
          <Waiter
            tooltipText={t("orders.KITCHEN_BUTTON")}
            useWrapClass={classNames(
              "controlAction",
              "canceled",
              "rightDirection"
            )}
            useTextClass="action-description"
            useSvg="#icon-pan"
            useSvgClass={classNames("actionIcon", "order-kitchen")}
            spanText={t("orders.KITCHEN_BUTTON")}
            type={WAITER_TYPES.buttonSpan}
            handleOnClick={() => handleOnChangeOrderState(item.state + 1)}
            stopPropagation={true}
          />
        )}
        {item.state === ORDER_STATE.kitchen && (
          <Waiter
            tooltipText={t("orders.DELIVERY_BUTTON")}
            useWrapClass={classNames("controlAction", "canceled")}
            useTextClass="action-description"
            useSvg="#icon-arrow-right"
            useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
            spanText={t("orders.DELIVERY_BUTTON")}
            type={WAITER_TYPES.buttonSpan}
            handleOnClick={() => handleOnChangeOrderState(item.state + 1)}
            stopPropagation={true}
          />
        )}
        {item.state === ORDER_STATE.ready &&
          getIsShowAssociate && (
            <Waiter
              tooltipText={t("orders.ASSOCIATE_BUTTON")}
              useWrapClass={classNames(
                "controlAction",
                "canceled",
                "ready",
                "rightDirection"
              )}
              useTextClass="action-description"
              useSvg="#icon-arrow-right"
              useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
              spanText={t("orders.ASSOCIATE_BUTTON")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={handleOpenAssociatePopup}
              stopPropagation={true}
            />
          )}
        {item.state === ORDER_STATE.ready && getIsShowPickedUp && (
          <Waiter
            tooltipText={t("orders.PICKED_UP_BUTTON")}
            useWrapClass={classNames("controlAction", "canceled", 'pickedup')}
            useTextClass="action-description"
            useSvg="#icon-arrow-top"
            useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
            spanText={t("orders.PICKED_UP_BUTTON")}
            type={WAITER_TYPES.buttonSpan}
            handleOnClick={() => handleOnChangeOrderState(4)}
            stopPropagation={true}
          />
        )}
        {item.state === ORDER_STATE.ready &&
          getIsShowReady && (
            <Waiter
              tooltipText={t("orders.READY_LABEL")}
              useWrapClass={classNames("controlAction")}
              useTextClass="action-description"
              useSvg="#icon-check"
              useSvgClass={classNames("actionIcon")}
              spanText={t("orders.READY_LABEL")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={() => {
                return new Promise(resolve => {
                  resolve();
                });
              }}
              stopPropagation={true}
              disabled={true}
            />
          )}
        {item.state === ORDER_STATE.onroute && (
          <Waiter
            tooltipText={t("orders.DISPATCHED_BUTTON")}
            useWrapClass={classNames("controlAction")}
            useTextClass="action-description"
            useSvg="#icon-check"
            useSvgClass={classNames("actionIcon")}
            spanText={t("orders.DISPATCHED_BUTTON")}
            type={WAITER_TYPES.buttonSpan}
            handleOnClick={() => {
              return new Promise(resolve => {
                resolve();
              });
            }}
            stopPropagation={true}
            disabled={true}
          />
        )}
        {item.state === ORDER_STATE.delivered && (
          <Waiter
            tooltipText={t("orders.DELIVERED_BUTTON")}
            useWrapClass={classNames("controlAction")}
            useTextClass="action-description"
            useSvg="#icon-check"
            useSvgClass={classNames("actionIcon")}
            spanText={t("orders.DELIVERED_BUTTON")}
            type={WAITER_TYPES.buttonSpan}
            handleOnClick={() => {
              return new Promise(resolve => {
                resolve();
              });
            }}
            stopPropagation={true}
            disabled={true}
          />
        )}
        {item.state === ORDER_STATE.canceled && (
          <Waiter type={WAITER_TYPES.buttonSpan}
            tooltipText={t("orders.CANCELED_BUTTON")}
            useWrapClass={classNames("controlAction", "closed")}
            useTextClass="action-description"
            spanText={t("orders.CANCELED_BUTTON")}            
            handleOnClick={() => new Promise(resolve => resolve())}
            stopPropagation={true}
            disabled={true}
          />
        )}
        {isAssistanceOrder && (
          <div className={classNames("receiveLabel")}>
            <TimeBox date={item.date} />
          </div>
        )}
      </div>
      {item.state < 4 && (
        <div className={classNames("titleBlock", "time")}>
          <span>{t("orders.TARGET_TIME_LABEL")}:</span>
          {getConvertedTargetTime(item) && (
            <span>{getConvertedTargetTime(item)}</span>
          )}
          {!getConvertedTargetTime(item) && (
            <span>{t("orders.ASAP_LABEL")}</span>
          )}
        </div>
      )}
      <EditButtonsBlock 
        id={item.id}
        orderState={item.state} 
        serviceNotes={item.serviceNotes}
        showConfirmDialog={showConfirmDialog}
        isWithPassword={isWithPassword}
        courierConfirmDialogType={courierConfirmDialogType}
        handleOnConfirmDialog={handleOnConfirmDialog}
        handleOnCancelConfirmDialog={handleOnCancelConfirmDialog}
        handleOnEdit={handleOnEdit}
        handleOnDeleteClick={() =>
          handleOnShowConfirmDialog(
            CONFIRM_DIALOG_TYPE.deleteItem,
            !isAllowOrderDeleteWithoutPassword()
          )
        }
        handleOnPreviewClick={handleOnPreviewClick}
        handleOnRevertClick={() =>
          handleOnShowConfirmDialog(CONFIRM_DIALOG_TYPE.reload, false)
        }
      />
    </div>
  </div>
);

const mapStateToProps = state => {
  return {
      showOrderPaymentStatus: state.restaurant &&
          state.restaurant.data.configuration && 
          state.restaurant.data.configuration.showOrderPaymentStatus
  };
};

export default connect(mapStateToProps, null)(withTranslation()(ActiveOrderInfoMore));
